import LoginForm from "features/identity/LoginForm";
import PasswordRecoveryStages from "features/identity/password-recovery-request/passwordRecoveryStages";
import { AnimatePresence } from "framer-motion";
import PublicLayout from "layouts/PublicLayout";
import { Navigate, Route, Routes } from "react-router-dom";
import ChangeEmailRequestPublic from "../features/home/my-profile/changeEmailRequest/changeEmailRequestPublic";
import RegisterStages from "../features/identity/register/registerStages";
import { SharedPublicRoutes } from "./SharedPublicRoutes";

export default function PublicRouter() {
  //const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes /*key={location.pathname} location={location}*/>
        <Route path="/" element={<PublicLayout />}>
          <Route path="login" element={<LoginForm />} />
          <Route path="register" element={<RegisterStages />} />
          <Route path="register/:token/" element={<RegisterStages />} />
          <Route
            path="password-recovery"
            element={<PasswordRecoveryStages />}
          />
          <Route
            path="password-recovery/:token/"
            element={<PasswordRecoveryStages />}
          />
          <Route
            path="change-email/:token/"
            key={""}
            element={<ChangeEmailRequestPublic />}
          />
          {SharedPublicRoutes}
          <Route path="*" element={<Navigate to="login" />} />
          <Route path="" element={<Navigate to="login" />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}
